import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Form1.css";

const Form1 = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullName: "",
    mobile: "",
    email: "",
    city: "",
  });
  const validCities = [
    "Mumbai",
    "Delhi",
    "Bengaluru",
    "Hyderabad",
    "Ahmedabad",
    "Chennai",
    "Kolkata",
    "Surat",
    "Pune",
    "Jaipur",
    "Lucknow",
    "Kanpur",
    "Nagpur",
    "Indore",
    "Bhopal",
    "Patna",
    "Visakhapatnam",
    "Vadodara",
    "Ludhiana",
    "Agra",
    "Nashik",
    "Faridabad",
    "Meerut",
    "Rajkot",
    "Varanasi",
    "Srinagar",
    "Aurangabad",
    "Dhanbad",
    "Amritsar",
    "Prayagraj",
    "Goa",
  ];


  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

const validate = () => {
  let err = {};

  // Full Name
  if (!formData.fullName.trim()) {
    err.fullName = "Full Name is required";
  }

  // Mobile Number
  if (!formData.mobile.trim()) {
    err.mobile = "Mobile Number is required";
  } else if (!/^[0-9]{10}$/.test(formData.mobile)) {
    err.mobile = "Invalid mobile number";
  }

  // Email
  if (!formData.email.trim()) {
    err.email = "Email is required";
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    err.email = "Invalid email address";
  }

  // City
  // City Validation
  if (!formData.city.trim()) {
    err.city = "City is required";
  } else if (
    !validCities.includes(
      formData.city.trim().charAt(0).toUpperCase() +
        formData.city.trim().slice(1).toLowerCase(),
    )
  ) {
    err.city = "Invalid city name";
  }

  setErrors(err);
  return Object.keys(err).length === 0;
};;


const handleSubmit = (e) => {
  e.preventDefault();

  const isValid = validate();

  if (isValid) {
    navigate("/form2");
  }
};


  return (
    <div className="main-container">
      <div className="left-side">
        <h1>Customer Basic Details</h1>
      </div>

      <div className="right-side">
        <form onSubmit={handleSubmit} className="form-box">
          <label>Full Name</label>
          <input
            type="text"
            name="fullName"
            placeholder="Enter your full name"
            value={formData.fullName}
            onChange={handleChange}
          />
          {errors.fullName && <p className="error">{errors.fullName}</p>}

          <label>Mobile Number</label>
          <input
            type="text"
            name="mobile"
            placeholder="Enter your mobile number"
            value={formData.mobile}
            onChange={handleChange}
          />
          {errors.mobile && <p className="error">{errors.mobile}</p>}

          <label>Email ID</label>
          <input
            type="text"
            name="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && <p className="error">{errors.email}</p>}

          <label>City of Residence</label>
          <input
            type="text"
            name="city"
            placeholder="Enter your city"
            value={formData.city}
            onChange={handleChange}
          />
          {errors.city && <p className="error">{errors.city}</p>}

      <button type="submit" className="next-btn">
            Next
          </button>
        </form>
      </div>
    </div>
  );
};

export default Form1;
